import React from 'react'
import AppGridLayoutDesiger from 'modules/modeling/page/AppGridLayoutDesiger/AppGridLayoutDesiger'

export const GirdLayoutDesiger = () => {
	return <AppGridLayoutDesiger />
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/GirdLayoutDesiger.tsx